import { ProjectStoreService } from '@modules/projects/shared/services/project-store.service';
import { Component, computed, inject, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProjectCreatorManage } from '@modules/project-creator/pages/project-creator-manage/project-creator-manage.component';
import { Project } from '@modules/projects/shared/models/project.model';

@Component({
  selector: 'app-projects-configurator',
  templateUrl: './projects-configurator.component.html',
  styleUrls: ['./projects-configurator.component.scss']
})
export class ProjectsConfiguratorComponent {
  protected readonly projectStore = inject(ProjectStoreService);
  protected readonly active = inject(ActivatedRoute);

  @ViewChild('configurator') configurator: ProjectCreatorManage;

  protected project = computed<Project | null>(
    () => this.projectStore.project() || this.projectStore.projectCtrl.project || null
  );

  protected projectConfiguratorConfig = {
    firstStep: {
      showProjectName: true
    },
    secondStep: {
      showInternalDocumentation: true,
      internal: true
    },
    thirdStep: {},
    fourthStep: {
      internal: true
    }
  };
}
